import { getApiActionTypes } from '../../../shared/store/storeHelpers';

export const fetchPartnershipFlowThroughAmountsTypes = getApiActionTypes(
  'FETCH_PARTNERSHIP_FLOW_THROUGH_AMOUNTS',
);

export const FLOW_THROUGH_AMOUNTS_SET_ACCOUNT_ID = 'FLOW_THROUGH_AMOUNTS_SET_ACCOUNT_ID';
export const FLOW_THROUGH_AMOUNTS_SET_JURISDICTION_ID = 'FLOW_THROUGH_AMOUNTS_SET_JURISDICTION_ID';
